import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-14a.svg'

const data = {
  question:
    'Which statement best describes the health risks of vaping/using e-cigarettes?',
  inputType: 'radio',
  options: [
    {
      label:
        'These products deliver fewer toxic chemicals than regular cigarettes, so therefore, there is little health risk.',
    },
    {
      label:
        'Although these products contain nicotine, since they are mostly water vapor, the only health risk is addiction.',
    },
    {
      label:
        "Although we don't know all of the effects of vaping yet, we do know that vaping poses significant health risks",
    },
    {
      label:
        'Unlike regular cigarettes, these products do not contain nicotine and are not addictive, so they are relatively safe.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[2].label,
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 1',
  path: '/challenge/question-1',
  content: (
    <Fragment>
      <Intro title="Question 1" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question1.js